import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { MaterialModule } from "@app/material.module";
import { LoaderModule } from "@app/shared/loader/loader.module";
import { TimeInputModule } from "@app/shared/time-input/time-input.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { DateFnsModule } from "ngx-date-fns";
import { UserSinglePickerDialogModule } from "../user-single-picker-dialog/user-single-picker-dialog.module";
import { ComeAndGoRulebreakFixDialogComponent } from "./come-and-go-rulebreak-dialog.component";

@NgModule({
	declarations: [ComeAndGoRulebreakFixDialogComponent],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		LoaderModule,
		UserAvatarModule,
		UserSinglePickerDialogModule,
		TimeInputModule,
		DateFnsModule,
		CustomPipesModule,
	],
})
export class ComeAndGoRulebreakFixDialogModule {}
